<template>
	
	<div class="dark">
		
		<div id="wrapper">
			<div id="preloader" class="gradiente-spinner" style="z-index: 999">
				<div id="spinner" class="spinner large-icon">
					<Spinner />
					<h2 id="cargando" class="line-height-1 font-18">
						Cargando
					</h2>
				</div>
				<!-- <div id="disable-preloader" class="btn btn-default btn-sm">Disable Preloader</div> -->
			</div>

			<Header />
			<div v-if="$route.path !== '/'" :class="{ 'visible': $route.path !== '/' }" class="Publicidad">
				<Publicidad />
			</div>
			<router-view />
			<Footer />

		</div>

	</div>

</template>

<script>
import Spinner from "./components/Spinner.vue";
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";

import Publicidad from "@/components/Publicidad/Publicidad.vue";

import { mapGetters } from "vuex";

export default {
	async mounted() {
		// if (this.extranjeros === [] || this.extranjeros)
		// await this.$store.dispatch("getExtranjeros");
	},
	computed: {
		...mapGetters(["extranjeros"]),
	},
	components: {
		Spinner,
		Footer,
		Header,
		Publicidad,
	},
};
</script>

<style>
.Publicidad {
    display: none !important; /* Keep this if needed elsewhere */
}
.Publicidad.visible {
	width: 100%;
	max-width: 65rem;

	margin: 0 auto;
	margin-top: 2rem;

	padding-right: .5rem;

    display: block !important; /* Override when visible */
}

:root {
	--verde-poa: #65c178;
}

#app {
	overflow-x: hidden;
}

.gradiente-spinner {
	background: rgb(57, 111, 165) !important;
}

#cargando {
	color: white !important;
}

#spinner {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	position: initial;
}

#preloader {
	z-index: 100;
}

.poa-btn {
	cursor: pointer;
	color: #65c178;
	padding: 0.5em 1em;

	border: 1px solid #65c178;
	user-select: none;
}

::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #212021;
}

::-webkit-scrollbar-thumb {
	background: #65c079;
	border-radius: 10px;

	transition: 0.2s;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #55a366;
}

::-webkit-scrollbar-corner {
	background: #212021;
}
</style>
